"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "esino-lario": {
    "a6106fbf": [{
      "hkey": "5de3d445",
      "slug": "esino-lario",
      "name": "Esino Lario",
      "primary": true,
      "skipSearch": false
    }],
    "bogani": [{
      "hkey": "5de3d445",
      "slug": "esino-lario",
      "name": "Esino Lario",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "74cd7b7c": [{
      "hkey": "5de3d445",
      "slug": "esino-lario",
      "name": "Esino Lario",
      "primary": true,
      "skipSearch": false
    }],
    "cainallo": [{
      "hkey": "5de3d445",
      "slug": "esino-lario",
      "name": "Esino Lario",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "db781d78": [{
      "hkey": "5de3d445",
      "slug": "esino-lario",
      "name": "Esino Lario",
      "primary": true,
      "skipSearch": false
    }],
    "gromeduccio": [{
      "hkey": "5de3d445",
      "slug": "esino-lario",
      "name": "Esino Lario",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2125290f": [{
      "hkey": "5de3d445",
      "slug": "esino-lario",
      "name": "Esino Lario",
      "primary": true,
      "skipSearch": false
    }],
    "rifugio-arnaldo": [{
      "hkey": "5de3d445",
      "slug": "esino-lario",
      "name": "Esino Lario",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;